var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeCancellation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#134A81",
    stroke: "#FFF",
    d: "M37.46 16.508h34.921a4.417 4.417 0 014.444 4.444v3.175H46.857c-1.143 0-1.714 1.397-.889 2.159l6.857 6.857c.699.698 1.715 1.143 2.667 1.143h21.333v18.412c0 1.08.826 1.905 1.905 1.905a1.87 1.87 0 001.905-1.905V20.952a8.238 8.238 0 00-8.254-8.254h-34.92c-1.08 0-1.905.826-1.905 1.905 0 1.08.825 1.905 1.904 1.905zM7.81 67.302h57.396l4.508 4.508c.381.38.89.571 1.334.571.444 0 .952-.19 1.333-.571.762-.762.762-1.969 0-2.667L16.508 13.27s0 0 0 0L3.81.57c-.762-.76-1.97-.76-2.667.001-.762.762-.762 1.969 0 2.667l9.524 9.46H8.889a8.237 8.237 0 00-8.254 8.254v39.175c0 3.936 3.238 7.175 7.175 7.175zm0-3.81c-1.842 0-3.366-1.524-3.366-3.365V34.286h27.81L61.46 63.492H7.81zm1.079-46.984h5.587l7.62 7.619H4.443v-3.175a4.417 4.417 0 014.445-4.444z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.73,
    cy: 78.095,
    r: 1.905,
    fill: "#396E9A"
  }))));
}
export default SvgFreeCancellation;